import { useQuery } from "@tanstack/react-query";
import { listEquipment, type Equipment } from "@/integrations/backend/equipment";
import { CATALOG_STALE_BASE_MS, staleTimeWithJitterFromKey } from "@/lib/query-cache";
import { queryKeys } from "@/lib/query-keys";

export function useEquipment() {
  const qk = queryKeys.equipment.all;
  const q = useQuery({
    queryKey: qk,
    queryFn: listEquipment,
    staleTime: staleTimeWithJitterFromKey(CATALOG_STALE_BASE_MS, [...qk]),
  });
  return { data: (q.data ?? []) as Equipment[], loading: q.isPending, error: q.error };
}
